export const OFFERING_OPTION_IN_PLAN = 1
export const OFFERING_OPTION_NOT_IN_PLAN = 2

export const REGISTER_STATE_REGISTERED = 1
export const REGISTER_STATE_OFFERING_LIST = 2
export const REGISTER_STATE_OFFERING_OPTIONS = 3
export const REGISTER_STATE_AUTH = 4
export const REGISTER_STATE_SUBSCRIBE = 5
export const REGISTER_STATE_PAYMENT = 6
export const REGISTER_STATE_REGISTERABLE = 7
export const REGISTER_STATE_UNUSABLE_SUBSCRIPTION = 8
export const REGISTER_STATE_REGISTRATION_CLOSED = 9
